<template>
  <el-container>
    <main class="tab__container">
      <h2 class="page__title">Клиенты</h2>
      <el-tabs v-model="activeTab">
        <el-tab-pane v-for="(tab, i) in tabs" :name="tab.key" :label="tab.name" :key="i">
          <component :is="tab.component" />
        </el-tab-pane>
      </el-tabs>
    </main>
  </el-container>
</template>

<script>
import ClientsList from "@/components/Clients/tabs/ClientsList";
import ClientsLogs from "@/components/Clients/tabs/ClientsLogs";

export default {
  name: "Clients",
  data() {
    return {
      activeTab: "list",
      tabs: [
        {
          name: "Список",
          key: "list",
          component: ClientsList,
        },
        {
          name: "Логи",
          key: "logs",
          component: ClientsLogs,
        },
      ],
    };
  },
};
</script>
